

<div class="top-background" style="background-image:url(images/backgrounds/about.jpg);">
    <h1 class="page-title">About the LCML</h1>
    <!-- Credit to the photographer (not required but still giving it) -->
    <div class="credit">
        Photo by <a href="https://unsplash.com/@danedeaner?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Dane Deaner</a>
    </div>
</div>

<section id="contact">

    <div class="content">
        <h1>A multidisciplinary approach to life cycle-based sustainability</h1><br>
        <p>Modern societies require decision makers to identify sustainable solutions that address many, often-conflicting, objectives. Using a life cycle thinking approach, the Life Cycle Management Laboratory (LCML) is providing novel solutions for current and future decision makers.</p>
        <p>Established in 2011, the LCML is a University of British Columbia (UBC) research unit with expertise in life cycle assessments. The facility is nestled in UBC’s Okanagan Campus of UBC. The LCML is the only research facility in Western Canada focusing on life cycle assessments of the built environment. The lab’s resources include more than 30 state-of-the-art software and databases, and the relevant hardware to perform thorough life cycle assessments. The LCML focuses its research efforts on life cycle thinking studies related to urban development, energy systems, construction & asset management, water systems, and industrial products & processes.</p>
        <p>The LCML research team is composed of 20+ graduate students and post-doctoral fellows. The LCML has made significant contributions to the international research community. To date, the lab’s researchers have over 200 journal and 100 conference publications, as well as 40 technical reports. </p>
        
        <img class="about-diagram" src="images/about-diagram.jpg" alt="Diagram about research areas">
    </div>

</section>




<style lang="sass">

@import "../consts.sass"
@include page-header()

.content
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

    .about-diagram
        width: 100%
        
</style>